<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="rect">
      您的评价对我们很重要！评价内容将会公开展示
      <van-rate
        v-if="isFirst"
        v-model="formData.score"
        class="score"
        :size="25"
        :color="GetColorMain()"
        void-icon="star"
        void-color="#ddd"
      />
      <div class="commentRect">
        <textarea v-model="commentBody" class="commentBody" rows="6" :maxlength="maxFont" />
        <div class="commnetFontNum">还可以输入{{ maxFont-nowFont }}字</div>
      </div>
      <van-uploader
        v-model="fileList"
        class="imageUpload"
        multiple
        :max-count="5"
        :after-read="afterRead"
      />
      <div class="anonymous">
        <van-checkbox v-model="formData.isAnonymous" class="checkBox" :checked-color="GetColorMain()">匿名评论</van-checkbox>
      </div>

    </div>
    <div class="downButton">
      <van-button type="info" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onComment">提交评论</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { getUrlKey, MyNotify, compressorImageList } from '@/utils/base'
import { Button, Rate, Uploader, Checkbox } from 'vant'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Rate.name]: Rate,
    [Uploader.name]: Uploader,
    [Checkbox.name]: Checkbox,
    TopBar
  },
  data() {
    return {
      title: '评价',
      backurl: '/store/orderList',
      maxFont: 5000,
      nowFont: 0,
      commentBody: '',
      buttonLoading: false,
      isFirst: false,
      fileList: [],
      formData: {
        orderId: undefined,
        commodityId: undefined,
        specificationId: undefined,
        specificationOthers: undefined,
        score: undefined,
        isAnonymous: false,
        body: '',
        res: undefined
      }
    }
  },
  watch: {
    commentBody(newValue, oldValue) {
      this.nowFont = newValue.length
      this.formData.body = newValue
    }
  },
  created() {
    this.formData.orderId = this.$route.params.id
    this.formData.commodityId = getUrlKey('commodityId')
    this.formData.specificationId = getUrlKey('specificationMain')
    this.formData.specificationOthers = getUrlKey('specificationOther')
    this.init()
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
      request({
        url: '/StoreHelper/getIsComment',
        method: 'post',
        data: this.formData
      }).then(response => {
        if (!response.success) {
          return
        }
        this.isFirst = !response.data
      })
    },
    afterRead(file) {
      console.log('file', file)
    },
    uploadImg(callback) {
      var noFile = true
      var fileList = []
      this.fileList.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          callback()
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=storecomment',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          this.formData.res = list.toString()
          if (callback) {
            callback()
          }
        })
      })
    },
    onComment() {
      if (this.isFirst && this.formData.score === 0) {
        MyNotify('error', '请给我们进行评分!')
        return
      }
      this.buttonLoading = true
      this.uploadImg(() => {
        // 上传数据
        request({
          url: '/StoreHelper/addComment',
          method: 'post',
          data: this.formData
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '发布评价成功', 3000)
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push(this.backUrl)
        })
      })
    }
  }
}
</script>
<style scoped>
.rect{
    padding: 1em 1em 0 1em;
    margin:1em 1em 0 1em;
    border-radius: 0.5em;
    background-color: #fff;
}
.rect .score{
    margin-top: 0.6em;
}
.rect .commentRect{
    margin-top: 1em;
    border: 1px solid #cacaca;
    padding: 0.5em;
}
.rect .commentBody{
    width: 99%;
    resize: none;
    border: none;
}
.rect .commnetFontNum{
    text-align: right;
    font-size: 0.7em;
    color: #999;
}
.rect .imageUpload{
  margin-top: 1em;
}
.rect .anonymous{
height: 3em;
position: relative;
}
.rect .anonymous .checkBox{
  width: 7em;
  font-size: 0.7em;
  height: 3em;
  position: absolute;
  right: 0;
}

.downButton
{
  margin: 1em;
}
.downButton button{
  border-radius: 0.5em;
  overflow: hidden;
}
</style>

